import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

// component
import { Table } from '../components/commons/table';
import { BadgeServiceStatus } from '../components/commons/badge.service.status';

// reducers
import { listNewPartnerApplicant } from '../stores/applicant.partners';

const columnDefs = (navigation) => {
  return {
    default: [
      {
        name: 'Customer',
        style: 'py-4 pl-4 text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { name, email, phone_number } = row.customer;
          return (
            <td>
              <Link to={`/jobs/details?user_id=${row.user_id}&job_id=${row.job_id}`}>
                <h4 className='px-4 text-sm text-secondary-500 font-bold underline hover:cursor-pointer'>{name}</h4>
                <p className='px-4 text-sm text-slate-500 font-light'>{email}</p>
                <p className='px-4 text-sm text-slate-500 font-light'>{phone_number}</p>
              </Link>
            </td>

          )
        },
      },
      {
        name: 'Status',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          return (
            <td className="py-4">
              <BadgeServiceStatus status={row.status} />
            </td>
          )
        },
      },
      {
        name: 'Date Created',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          return (
            <td className="py-4">
              <p className='text-sm text-slate-600 font-normal'>{moment(row.created).format('llll')}</p>
              <p className='text-xs text-slate-700 font-normal'>({moment(row.modified).fromNow()})</p>
            </td>
          )
        },
      },
      {
        name: 'Service',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { name } = row.product;
          return (
            <td className="py-4">
              <p className='text-sm text-slate-600 font-normal'>{name}</p>
            </td>
          )
        },
      },
      {
        name: 'Premise',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { address } = row.premise;
          return (
            <td className="py-4">
              <p className='text-sm text-slate-700 font-normal'>{address.address1}</p>
              <p className='text-sm text-slate-700 font-normal'>{address.address2}</p>
              <p className='text-sm text-slate-700 font-normal'>{address.poscode}, {address.city}</p>
              <p className='text-sm text-slate-700 font-normal'>{address.state}</p>
            </td>
          )
        },
      },
    ],
  }
}

export const TableSearchJobs = ({ data = [] }) => {

  // hooks
  const dispatch = useDispatch();
  const { items = [], next_token } = useSelector(context => context.jobsSearch);
  const navigation = useNavigate();

  return (
    <div className='mt-8'>
      <div className='mt-4 rounded-md shadow-md'>
        <Table
          className='rounded-md'
          data={items}
          columnDefs={columnDefs(navigation)}
          hasMorePages={next_token ? true : false}
          // onLoadMore={() => loaddata(next_token)}
        />
      </div>
    </div>
  )
}